import React, { useState } from "react";
import { ChevronDownIcon, ChevronUpIcon } from "lucide-react";

const FAQSection = ({ questions = [] }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="w-full mx-auto  flex flex-col gap-3">
      {questions.map((item, index) => (
        <div
          key={index}
          className="border border-[#CBD5E0] rounded-xl cursor-pointer p-6 lg:p-[16px]"
          onClick={() => toggleAccordion(index)}
        >
          <div className="flex justify-between items-center">
            <h3 className=" text-base font-semibold text-dark font-inter lg:text-[20px] lg:leading-[23.78px]">
              {item.question}
            </h3>
            <button className="text-content transition-colors">
              {activeIndex === index ? (
                <ChevronUpIcon className="w-6 h-6 lg:w-6 lg:h-6" />
              ) : (
                <ChevronDownIcon className="w-6 h-6 lg:w-6 lg:h-6" />
              )}
            </button>
          </div>
          {activeIndex === index && (
            <div className="pt-4 lg:pt-4 font-inter text-sm lg:text-[16px] lg:leading-[25.48px] text-[#303A42]">
              {item.answer}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default FAQSection;
